import React from "react";
import clsx from "clsx";

const NavItem = ({ icon, label, active = false, isCollapsed = false, onClick }) => {
  return (
    <button
      className={clsx(
        "flex items-center w-full transition-colors",
        isCollapsed ? "justify-center px-4 py-3" : "gap-3 px-6 py-3 text-left",
        "text-sm font-medium",
        active
          ? "text-primary"
          : "text-gray-600 hover:text-gray-800"
      )}
      onClick={onClick}
      title={isCollapsed ? label : ''}
    >
      {icon}
      {!isCollapsed && <span>{label}</span>}
    </button>
  );
};

export default NavItem;
